import { gql } from '@apollo/client';

// Operation names deliberately differ from the backend field names
// (myLessonHomework / lessonHomework / homeworkRoster / …) — equal names make
// codegen collapse the generated result type into the schema payload type.

/** Student view: the assignment plus the student's own submission (spec 0012 §4). */
export const MyLessonHomeworkQuery = gql`
  query MyLessonHomework($lessonId: ID!) {
    myLessonHomework(lessonId: $lessonId) {
      id
      lessonId
      hasTeacherAssignment
      title
      text
      dueDate
      canSubmit
      mySubmission {
        id
        githubUrl
        fileName
        status
        attempt
        submittedAt
        hwMark
        teacherComment
      }
    }
  }
`;

/** Staff view of the assignment (Teacher of the group + Methodist read-only). */
export const LmsLessonHomeworkQuery = gql`
  query LmsLessonHomework($lessonId: ID!) {
    lessonHomework(lessonId: $lessonId) {
      id
      lessonId
      title
      text
      dueDate
      updatedAt
    }
  }
`;

/**
 * Teacher roster: every student of the lesson, submitted or not (spec 0012 §4).
 *
 * `homeworkAiEnabled` rides along as a second root field (no extra request):
 * with HOMEWORK_AI_ENABLED off the whole AI pipeline is dark, and the drawer
 * must hide the AI card + re-run control instead of offering a button that
 * always fails with AI_DISABLED.
 */
export const LmsHomeworkRosterQuery = gql`
  query LmsHomeworkRoster($lessonId: ID!) {
    homeworkAiEnabled
    homeworkRoster(lessonId: $lessonId) {
      studentId
      studentName
      hwMark
      submission {
        id
        githubUrl
        fileName
        fileSizeBytes
        status
        attempt
        submittedAt
        teacherComment
        gradedAt
        gradedByName
        aiReview {
          status
          aiScore
          aiSummary
          aiJustification
          suspiciousContent
          suspicionNotes
          errorMessage
          analyzedAt
          truncatedBasis
          filesUsedCount
          assignmentSource
        }
      }
    }
  }
`;

/**
 * Short-TTL presigned GET link for a ZIP submission — always fetch it lazily
 * with a network fetch policy, never serve it from the cache.
 */
export const LmsHomeworkSubmissionDownloadUrlQuery = gql`
  query LmsHomeworkSubmissionDownloadUrl($submissionId: ID!) {
    homeworkSubmissionDownloadUrl(submissionId: $submissionId)
  }
`;
